// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyPdpCta_root__PsS5u","info":"StickyPdpCta_info__3tPU9","title":"StickyPdpCta_title__tN_xt","price":"StickyPdpCta_price__Vc5ti"};